import React, { useState } from 'react'

import {
  Divider,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
  withStyles
} from '@material-ui/core'

import {
  ChevronLeft as ChevronLeftIcon,
  Menu as MenuIcon
} from '@material-ui/icons'
import { getParams } from 'api/fieldNotebooks'

import './styles.css'

import AreasIcon from '../images/sidebar/areas.svg'
import MapsIcon from '../images/sidebar/maps.svg'
import EquipmentsIcon from '../images/sidebar/equipments.svg'
import InputsIcon from '../images/sidebar/inputs.svg'
import CulturesIcon from '../images/sidebar/cultures.svg'
import SeasonsIcon from '../images/sidebar/seasons.svg'
import StoreIcon from '../images/sidebar/store.svg'
import WidgetsIcon from '../images/sidebar/widgets.svg'
import Logo from './Logo'
import { useHistory } from 'react-router-dom'

const getSideBarOptions = showStore => [
  { text: 'Mapa', icon: MapsIcon, path: 'maps', key: 'map' },
  { text: 'Widgets', icon: WidgetsIcon, path: 'widgets', key: 'widgets' },
  { text: 'Areas', icon: AreasIcon, path: 'areas', key: 'areas' },
  { text: 'Equipamentos', icon: EquipmentsIcon, path: 'equipments', key: 'equipments' },
  { text: 'Culturas', icon: CulturesIcon, path: 'cultures', key: 'crops' },
  { text: 'Safras', icon: SeasonsIcon, path: 'seasons', key: 'seasons' },
  { text: 'Insumos', icon: InputsIcon, path: 'inputs', key: 'inputs' },
  { text: 'Loja', icon: StoreIcon, path: 'store', key: 'store', hide: !showStore }
]

export const SideBar = () => {
  const showStore = true
  let history = useHistory()
  const { o } = getParams(history.location.search)

  const [open, setOpen] = useState(false)

  const menuOptions = getSideBarOptions(showStore)

  const handleClick = (path, o) => {
    history.push(`/v4/o/${o}/${path}`)
    history.go()
  }

  return (
    <>
      {
        !open &&
        <IconButton
          onClick={() => setOpen(true)}
          data-intercom-target='left-side-menu'
        >
          <MenuIcon />
        </IconButton>
      }

      <SwipeableDrawer
        className={styles.drawer}
        classes='paper'
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <Grid container spacing={0}>
          <Grid item xs={10}>
            <a
              href={'/maps'}
              className={styles.menu__logoLink}
            >
              <Logo
                logo={''}
                smallLogo={''}
              />
            </a>
          </Grid>

          <Grid item xs={2}>
            <IconButton
              onClick={() => setOpen(false)}
            >
              <ChevronLeftIcon className={styles.SideBar_Icon__open} />
            </IconButton>
          </Grid>
        </Grid>

        <Divider />

        <List >
          {
            menuOptions.map(option => (
              !option.hide &&
              <div data-intercom-target={option.key} key={option.key}>
                <ListItem
                  onClick={() => handleClick(option.path, o)}
                  title={option.text}
                  key={option.text}
                  component={Link}
                  button
                >
                  <ListItemIcon
                  >
                    <span style={{
                      WebkitMask: `url(${option.icon}) no-repeat center`,
                      mask: `url(${option.icon}) no-repeat center`,
                      background: '#393939',
                      height: 23,
                      width: 22
                    }} />
                  </ListItemIcon>

                  <ListItemText
                    className={styles.SideBar_Icon__open}
                    secondary={option.text}
                  />
                </ListItem>
              </div>
            ))
          }
        </List>
      </SwipeableDrawer>
    </>
  )
}

const drawerWidth = 264

const styles = () => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  paper: {
    zIndex: 400,
    backgroundColor: '#FFF',
  },
  menu__logoLink: {
    textDecoration: 'none',
    display: 'grid',
  },
  SideBar_Icon__open: {
    color: '#393939'
  }
})

export default withStyles(styles)(SideBar)